var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 16,
    viewBox: "0 0 46 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2314_2960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9738 15.5888H16.2601L18.5811 0.919348H22.2951L19.9738 15.5888ZM13.136 0.919348L9.59558 11.0091L9.17664 8.83637L9.17702 8.83716L7.92744 2.24016C7.92744 2.24016 7.77635 0.919348 6.16582 0.919348H0.31282L0.244141 1.16774C0.244141 1.16774 2.034 1.55072 4.12872 2.84445L7.35512 15.5892H11.2244L17.1328 0.919348H13.136ZM42.3457 15.5888H45.7556L42.7825 0.918956H39.7973C38.4187 0.918956 38.083 2.01218 38.083 2.01218L32.5444 15.5888H36.4156L37.1898 13.4098H41.9107L42.3457 15.5888ZM38.2593 10.3997L40.2105 4.91004L41.3082 10.3997H38.2593ZM32.8347 4.44701L33.3647 1.29683C33.3647 1.29683 31.7294 0.657227 30.0246 0.657227C28.1817 0.657227 23.8053 1.48558 23.8053 5.51355C23.8053 9.30333 28.9418 9.35042 28.9418 11.3411C28.9418 13.3317 24.3345 12.975 22.8141 11.7197L22.2619 15.0135C22.2619 15.0135 23.9202 15.8419 26.4537 15.8419C28.9879 15.8419 32.8111 14.4924 32.8111 10.8196C32.8111 7.00544 27.6285 6.65032 27.6285 4.99205C27.6289 3.33338 31.2456 3.54645 32.8347 4.44701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17702 8.83675L7.92744 2.23976C7.92744 2.23976 7.77635 0.918945 6.16582 0.918945H0.31282L0.244141 1.16733C0.244141 1.16733 3.05732 1.76692 5.75565 4.0134C8.3357 6.1606 9.17702 8.83675 9.17702 8.83675Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2314_2960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 15,
    fill: "white",
    transform: "translate(0 0.749023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.67c5536df159754bbdcdfb6b0126d64f.svg";
export { ForwardRef as ReactComponent };